import React from "react";
import StyledDialog from "./StyledDialog";

// Generic confirm modal used by: delete lecture, delete homework, date-change
// confirmation, and the "Sisteme Yükle" cache publish. Confirmation gating on
// these actions is a preserved control — never bypass it.
const ConfirmDialog = ({
    open,
    onClose,
    onConfirm,
    text,
    imageUrl,
    lines = [],
    confirmLabel = "Onayla",
    cancelLabel = "Vazgeç",
    confirmVariant = "olp-btn--primary",
}) => {
    if (!open) return null;
    return (
        <StyledDialog open={open} onClose={onClose}>
            <div className="olp-theme olp-modal olp-modal--narrow">
                <div className="olp-confirm-body">
                    {imageUrl && <img src={imageUrl} alt="" />}
                    {lines.map((line, i) => (
                        <p key={i} style={{ margin: "2px 0" }}>
                            {line}
                        </p>
                    ))}
                    <p className="olp-confirm-text">{text}</p>
                    <div className="olp-confirm-actions">
                        <button
                            className={"olp-btn " + confirmVariant}
                            onClick={onConfirm}
                        >
                            {confirmLabel}
                        </button>
                        <button className="olp-btn" onClick={onClose}>
                            {cancelLabel}
                        </button>
                    </div>
                </div>
            </div>
        </StyledDialog>
    );
};

export default ConfirmDialog;
